var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`the-label design-${_vm.design}`},[(_vm.text)?_c('p',[_vm._v(_vm._s(_vm.text))]):_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }